import YHtance from "./request";
// 获取搜索简历信息
export const GetResumeList = (params) => YHtance.post("/admin/search", params);

// 获取当前简历ID信息
export const GetResumeInfo = (params) => YHtance.post("/admin/getresume", params);

// 修改基础信息
export const updateBaseInfo = (params) => YHtance.post("/admin/upbaseInfo", params);

// 设置时间
export const setTime = (params) => YHtance.post("/admin/setTime", params);
export const getTime = (params) => YHtance.post("/admin/getAllTime", params);

// 修改求职信息
export const updatewantJobInfo = (params) => YHtance.post("/admin/upwantJobInfo", params);

// 修改工作经历
export const updateworkInfo = (params) => YHtance.post("/admin/upworkInfo", params);
// 修改教育经历
export const updateeduInfo = (params) => YHtance.post("/admin/upeduInfo", params);
// 修改个人介绍
export const updateMyself = (params) => YHtance.post("/admin/upmyself", params);
// 修改项目经历
export const updateproject = (params) => YHtance.post("/admin/upproject", params);

// 删除工作经历
export const delWorkInfo = (params) => YHtance.post("/admin/DelWorkInfo", params);
// 删除教育经历
export const delEduInfo = (params) => YHtance.post("/admin/DelEduInfo", params);
// 删除项目经历
export const delProjInfo = (params) => YHtance.post("/admin/DelProjectInfo", params);
// 添加工作经历
export const AddWorkInfo = (params) => YHtance.post("/admin/AddWorkInfo", params);
// 添加教育经历
export const AddEduInfo = (params) => YHtance.post("/admin/AddEduInfo", params);
// 添加项目经历
export const AddProjInfo = (params) => YHtance.post("/admin/AddProjectInfo", params);
// 上传简历信息
export const AddResume = (params) => YHtance.post("/admin/uploadResume", params);


// AI生成面试题库/人岗匹配分析
export const AImstw = (params) => YHtance.post("/admin/aimstw", params);
// 通过职位名称获取信息
export const jobNameGetAIKnow = (params) => YHtance.post("/admin/jobNameGetAIKnow", params);
// 获取职位列表
export const getLPJobList = (params) => YHtance.post("/admin/getLPJobList", params);
// 获取职位信息
export const getLPJobInfo = (params) => YHtance.post("/admin/getLPJobInfo", params);
// 创建职位信息
export const createLPJob = (params) => YHtance.post("/admin/createLPJob", params);
// 修改职位信息
export const updateLPJob = (params) => YHtance.post("/admin/updateLPJob", params);
// 删除职位信息
export const delectLPJob = (params) => YHtance.post("/admin/delectLPJob", params);
// 获取职位列表
export const getZLJobList = (params) => YHtance.post("/admin/getZLJobList", params);
// 获取职位信息
export const getZLJobInfo = (params) => YHtance.post("/admin/getZLJobInfo", params);
// 创建职位信息
export const createZLJob = (params) => YHtance.post("/admin/createZLJob", params);
// 修改职位信息
export const updateZLJob = (params) => YHtance.post("/admin/updateZLJob", params);
// 删除职位信息
export const delectZLJob = (params) => YHtance.post("/admin/delectZLJob", params);
// 获取职位列表
export const getJobList = (params) => YHtance.post("/admin/getJobList", params);
// 获取职位信息
export const getJobInfo = (params) => YHtance.post("/admin/getJobInfo", params);
// 创建职位信息
export const createJob = (params) => YHtance.post("/admin/createJob", params);
// 修改职位信息
export const updateJob = (params) => YHtance.post("/admin/updateJob", params);
// 删除职位信息
export const delectJob = (params) => YHtance.post("/admin/delectJob", params);
// 获取知识库
export const getKnow = (params) => YHtance.post("/admin/getKnow", params);
// 创建知识库
export const addKnow = (params) => YHtance.post("/admin/addKnow", params);
// 修改知识库
export const updateKnow = (params) => YHtance.post("/admin/upKnow", params);
// 删除知识库
export const delKnow = (params) => YHtance.post("/admin/delKnow", params);
// 获取复聊
export const getAgain = (params) => YHtance.post("/admin/getAgain", params);
// 创建复聊
export const addAgain = (params) => YHtance.post("/admin/addAgain", params);
// 修改复聊
export const updateAgain = (params) => YHtance.post("/admin/upAgain", params);
// 删除复聊
export const delAgain = (params) => YHtance.post("/admin/delAgain", params);

// 获取提问
export const getInterview = (params) => YHtance.post("/admin/getInterview", params);
// 创建提问
export const addInterview = (params) => YHtance.post("/admin/addInterview", params);
// 修改提问
export const upInterview = (params) => YHtance.post("/admin/upInterview", params);
// 删除提问
export const delInterview = (params) => YHtance.post("/admin/delInterview", params);

// 保存已读简历
export const readCache = (params) => YHtance.post("/admin/readCache", params);
// 获取名字拼音
export const getPinyin = (params) => YHtance.post("/admin/getNamePinYin", params);
// 登录Login
export const Login = (params) => YHtance.post("/admin/login", params);
export const updatePSW = (params) => YHtance.post("/admin/updatepsw", params);
export const saveUserInfo = (params) => YHtance.post("/admin/saveUserInfo", params);
export const getUserInfo = (params) => YHtance.post("/admin/getUserInfo", params);
export const addAppraise = (params) => YHtance.post("/admin/addAppraise", params);
export const getAppraise = (params) => YHtance.post("/admin/getAppraise", params);
export const GetComJobsInfo = (params) => YHtance.post("/admin/getComJob", params);

// 登记表配置信息
export const getRegConfig = (params) => YHtance.post("/admin/getRegConfig", params);
export const setRegConfig = (params) => YHtance.post("/admin/setRegConfig", params);
export const saveRegConfig = (params) => YHtance.post("/admin/updateRegConfig", params);